import { Injectable } from '@angular/core';
import { CanLoad, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MemberModel } from '../models/member.model';
import { AccessRolesService } from '../services/access-roles.service';

@Injectable()
export class CanLoadCommon implements CanLoad {
    public constructor(private accessRolesService: AccessRolesService) {}

    public canLoad(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return this.accessRolesService
            .getRole()
            .pipe(
                map(res => new MemberModel(res.member)),
                map(member => member.hasCommonAccess())
            );
    };
}
